import { fn0nZ } from '../../core/formatter/formatNumber';
import { getGewerk, getGewerkName, getWZobject } from './getGewerk';
import { IDs } from '../../helpers/IDs';
import * as Moment from 'moment';

export function processHinweise(data: any) {
    const konfig = data[IDs.ENT_KONFIGURATION];
    const jahrMax = Moment().year();
    let jahrMin = 2010;
    if (konfig && konfig[0] && konfig[0].startjahr_datenerfassung && konfig[0].startjahr_datenerfassung > 1900) {
        jahrMin = konfig[0].startjahr_datenerfassung;
    }
    if (!data[IDs.HINWEISE]) {
        data[IDs.HINWEISE] = {};
    }
    for (let jahr = jahrMin; jahr <= jahrMax; jahr++) {
        processHinweiseJahr(data, jahr);
    }
}

export function processHinweiseJahr(data: any, jahr: number) {
    data = data || {};
    const hinweise_loaded = data[IDs.ENT_ENERGIE_COCKPIT_HINWEISE];
    const kennzahlen_aggregiert = (data[IDs.ENT_KENNZAHLEN_WERTE_AGGREGATION] || [])
        .filter((item: any) => (item.modus || 100) === 100 && !item.zeitraum && !item.jahr);
    const kz_ee_anteil = kennzahlen_aggregiert.find((k: any) => k.kuerzel === 'eigenstrom_anteil');
    const val_ee_anteil = kz_ee_anteil ? kz_ee_anteil.wert_avg : 0.38;
    // console.log('KZ EE ANTEIL: ', val_ee_anteil);

    const items = [];
    const plausibel = (data.plausibel || {})[jahr] || [];

    // Gewerk
    // const gewerke = data[IDs.ENT_GEWERKE];
    const branchen_gewerke = data[IDs.ENT_BRANCHEN_GEWERKE] || [];
    const gewerk_tid = getGewerk(data);
    const gewerk_info = branchen_gewerke.find((item: any) => gewerk_tid && gewerk_tid === item.tid);
    const steckbrief = gewerk_info ? gewerk_info.datei : undefined;
    const plausibel_not_ok = plausibel.filter((item: any) => item.level !== 'ok');

    const gewerkName: string = (getGewerkName(data) || '').trim().toLowerCase();
    const disabledSteuerWz: boolean = (+(getWZobject(data) || {}).produzierendes_gewerbe || 0) === 0
        || gewerkName === 'kein handwerk' || gewerkName === 'handwerkskammer';
    const disabledSteuer = gewerkName === 'kein handwerk' || gewerkName === 'handwerkskammer' || disabledSteuerWz;

    // Steuererstattung prüfen
    const steuer_energie: any = data[IDs.STEUER_ENERGIE] || {};
    const data_steuer_energie: any = steuer_energie[jahr] || {};
    const steuer_strom: any = data[IDs.STEUER_STROM] || {};
    const data_steuer_strom: any = steuer_strom[jahr] || {};
    let summe_erstattung = data_steuer_energie.erstattung || 0;
    summe_erstattung += data_steuer_strom.erstattung || 0;
    // console.log('STEUER STROM', steuer_strom);
    // CO2-Mehrkosten
    const co2_mehrkosten = data[IDs.CO2_MEHRKOSTEN] ? data[IDs.CO2_MEHRKOSTEN][jahr] : undefined;

    // PV-Anlage
    let show_pv_hinweis = false;
    let strom_pv_einsparung = 0;
    const pv_anlagen = data[IDs.ENT_ANLAGEN_EIGENSTROM_PHOTOVOLTAIK];
    const eigenstrom = data[IDs.ENT_ENERGIEDATEN_EIGENSTROM];
    const pv_eigenstrom_item = eigenstrom && eigenstrom.find((item: any) => item.anlagen_eigenstrom_typ_tid === 'Photovoltaik');
    // console.log('EIGENSTROM: ', pv_eigenstrom_item);
    if ((pv_anlagen && pv_anlagen.length > 0) || pv_eigenstrom_item) {
        // console.log('KEIN  PV-Hinweis, da es eine PV-Anlage gibt');
    } else {
        const kennzahlen = data[IDs.KENNZIFFERN_BERECHNET];
        if (kennzahlen && kennzahlen[jahr] && kennzahlen[jahr].strom_kosten_gesamt > 0) {
            strom_pv_einsparung = kennzahlen[jahr].strom_kosten_gesamt * 0.38; // 0.6;
            show_pv_hinweis = true;
        }
    }

    // Regionales Umweltsystem
    const unternehmensdaten: any = ((data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {});
    // console.log('Untern: ', unternehmensdaten);
    const bundesland: any = (data[IDs.ENT_BUNDESLAND] || [])
        .find((item: any) => item.tid === (+unternehmensdaten.bundesland_orig || null)) || {};
    const umwelt_link: any = bundesland.regionales_umweltsystem_link || null;
    const umwelt_name: string = bundesland.regionales_umweltsystem_bezeichnung || null;

    // Gesamtenergieverbrauch
    const getGesamtverbrauch = (): number => {
        const kennzahlen: any = (data[IDs.KENNZIFFERN_BERECHNET] || {})[jahr] || {};
        const strom_kwh: number = kennzahlen.strom_verbrauch_gesamt || 0;
        const waerme_kwh: number = kennzahlen.waerme_kwh || 0;
        const kraftstoff_kwh: number = kennzahlen.kraftstoff_kwh || 0;
        const eigenstrom_kwh: number = kennzahlen.eigenstrom_verbrauch_kwh || 0;
        return strom_kwh + waerme_kwh + kraftstoff_kwh + eigenstrom_kwh;
    };

    if (plausibel_not_ok.length > 0) {
        const item_fehlt: any = {};
        item_fehlt.type = 'fehlt';
        item_fehlt.jahr = jahr;
        item_fehlt.value = plausibel_not_ok.length;
        item_fehlt.status = 0;
        items.push(item_fehlt);
    }
    if (show_pv_hinweis) {
        const item_pv: any = {};
        item_pv.type = 'pv';
        item_pv.jahr = jahr;
        item_pv.value = fn0nZ(strom_pv_einsparung);
        item_pv.status = 0;
        items.push(item_pv);
    }
    if (summe_erstattung && summe_erstattung > 0 && !disabledSteuer) {
        const item_steuer: any = {};
        item_steuer.type = 'steuer';
        item_steuer.jahr = jahr;
        item_steuer.value = summe_erstattung;
        item_steuer.status = 0;
        items.push(item_steuer);
    }
    if (co2_mehrkosten && co2_mehrkosten > 0) {
        const item_co2: any = {};
        item_co2.type = 'co2';
        item_co2.jahr = jahr;
        item_co2.value = co2_mehrkosten;
        item_co2.status = 0;
        items.push(item_co2);
    }
    if (steckbrief && steckbrief > 0) {
        const item_steckbrief: any = {};
        item_steckbrief.type = 'steckbrief';
        item_steckbrief.jahr = jahr;
        item_steckbrief.value = steckbrief;
        item_steckbrief.status = 0;
        items.push(item_steckbrief);
    }
    if (umwelt_name && umwelt_link) {
        const item_umwelt: any = {};
        item_umwelt.type = 'umwelt';
        item_umwelt.jahr = jahr;
        item_umwelt.value = { bezeichnung: umwelt_name, link: umwelt_link };
        item_umwelt.status = 0;
        items.push(item_umwelt);
    }
    if (getGesamtverbrauch() > 2500000) {
        const item_energieverbrauch: any = {};
        item_energieverbrauch.type = 'energieverbrauch';
        item_energieverbrauch.jahr = jahr;
        item_energieverbrauch.value = { bezeichnung: umwelt_name, link: umwelt_link };
        item_energieverbrauch.status = 0;
        items.push(item_energieverbrauch);
    }
    /*
    if (true) {
        const item_hinweis1: any = {};
        item_hinweis1.type = 'hinweis';
        item_hinweis1.jahr = jahr;
        item_hinweis1.value = 'Hier ein Hinweis, ohne Bestätigung ... ';
        item_hinweis1.status = 2;
        items.push(item_hinweis1);
    }
    if (true) {
        const item_hinweis2: any = {};
        item_hinweis2.type = 'hinweis';
        item_hinweis2.jahr = jahr;
        item_hinweis2.value = 'Und hier ist gleich noch ein Hinweis, ohne Bestätigung ...';
        item_hinweis2.status = 2;
        items.push(item_hinweis2);
    }
    */
    // Jetzt nochmal über alle Items iterieren und schauen, was wir davon schon in der DB haben
    items.forEach((item: any) => {
        if (item.status !== 2) { // Hinweise erst gar nicht prüfen, die werden nie gespeichert
            const found = hinweise_loaded && hinweise_loaded
                .find((hw: any) => (hw.jahr === jahr || hw.type === 'umwelt' /* jahresunabhängiger Status */) && hw.type === item.type);
            if (found) {
                item.status = found.status;
                item.tid = found.tid;
            } else {
                item.tid = 0;
            }
        }
    });
    data[IDs.HINWEISE][jahr] = items;
    // .content = <span>Es wurden {plausibel.length} fehlende Dateieingaben festgestellt.</span>
}
